/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/buttons/putOnHoldButton"/>
import * as ko from "knockout";
import { ReasonCodeOperationContainer } 
  from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/reasonCodeOperationModal/reasonCodeOperationContainer";
import { ReasonCodeOperationType } 
  from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/interfaces";
import { EntityType } 
  from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/interfaces";
import * as type from "Core/Medius.Core.Web/Scripts/Medius/core/type";

export default class PutOnHoldButton {
    public task: any;
    public putOnHoldModel: any;
    public show: ko.Observable<boolean>;
    public ReasonCodeOperationModal: ko.PureComputed<any>;

    constructor(params: { task: any; putOnHoldModel: any; }) {
        this.task = params.task;
        this.putOnHoldModel = params.putOnHoldModel;
        this.show = ko.observable(false);

        this.ReasonCodeOperationModal = ko.pureComputed(() => {
            const documentId: number = this.task?.Document?.().Id?.();
            const hierarchyId: string = this.task?.Document?.().Company?.().HierarchyId?.();
            const taskId: number = this.task?.Id?.();
            const documentType: string = this.task?.Document?.().$type?.();
            const entityType: EntityType = 
                documentType.includes("Medius.Core.Entities.Integration.EDIDocumentImport") ?
                    EntityType.EdiDocumentImport :
                    EntityType.SupplierInvoice

            return {
                functionComponent: ReasonCodeOperationContainer,
                props: {
                    show: this.show(),
                    documentId: documentId,
                    hierarchyId: hierarchyId,
                    modalType: ReasonCodeOperationType.PutOnHold,
                    taskId: taskId,
                    entityType: entityType,
                    currentDocumentType: type.getTypeName(documentType),
                    onClose: this.handleModalClose
                }
            };
        });
    }

    public handleModalClose = (wasConfirmed: boolean) => {
        if(wasConfirmed)
            this.putOnHoldModel.putOnHold();

        this.show(false);
    };

    public openOnHoldModal = () => {
        this.show(true);
    };
}
